"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripLow = void 0;
const assertString_1 = require("./util/assertString");
const blacklist_1 = require("./blacklist");
function stripLow(str, keep_new_lines) {
    (0, assertString_1.assertString)(str);
    const chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
    return (0, blacklist_1.blacklist)(str, chars);
}
exports.stripLow = stripLow;
